module.exports = __webpack_public_path__ + "img/imagem11.dca18e44.svg";